import { State } from 'xstate';
import { customFields } from './customFields';

export type CustomFieldsMachine = typeof customFields;
export type CustomFieldsState = State<CustomFieldsMachine['context']>;

export const getCustomFieldsState = (machineState: CustomFieldsState) => ({
  isFetchError: machineState.matches('error'),
  isEdit: machineState.matches('customFieldsEdit'),
  isSaving: machineState.matches('customFieldsEdit.saving'),
  isSaveError: machineState.matches('customFieldsEdit.error'),
});

export const getCustomFields = (machineState: CustomFieldsState) => ({
  customFields: machineState.context.customFields,
});

export const customFieldsSelectors = {
  getCustomFieldsState,
  getCustomFields,
};
